var React = require('react');

function GreenTick (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"7","cy":"7","r":"7","fill":"#229490","key":0}),React.createElement("line",{"x1":"3.35355","y1":"7.64645","x2":"5.35355","y2":"9.64645","stroke":"white","key":1}),React.createElement("line",{"x1":"4.67991","y1":"9.61589","x2":"10.6799","y2":"4.61589","stroke":"white","key":2})]);
}

GreenTick.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = GreenTick;

GreenTick.default = GreenTick;
